import styled from 'styled-components';
import breakpoint from '@carvana/helios-layout/breakpoint';
import { text } from '@carvana/helios-styles';
import body from '@carvana/helios-typography/body';
import heading from '@carvana/helios-typography/heading';

const InlineIcon = styled.div`
  display: inline;
  padding-right: 24px;
  height: 36px;

  ${breakpoint.md`
    padding-bottom: 16px;
  `}
`;

const Row = styled.div`
  display: flex;
  &:not(:last-child) {
    padding-bottom: 16px;
  }

  ${breakpoint.sm`
    &:not(:last-child) {
      padding-bottom: 24px;
    }
  `}

  ${breakpoint.md`
    padding-bottom: 0;
    flex-direction: column;
    padding-right: 16px;
    &:not(:last-child) {
      padding-bottom: 0;
    }

    &:not(:last-child) {
      margin-right: 24px;
    }
  `}
`;

const Rows = styled.div`
  display: flex;
  flex-direction: column;

  ${breakpoint.md`
    flex-direction: row;
  `}
`;

const Title = styled.h2`
  ${heading['2Xl']}
  color: ${text.strong};
  align-self: flex-start;
  padding-top: 40px;
  padding-bottom: 40px;
  max-width: 240px;
  text-transform: none;

  ${breakpoint.sm`
    align-self: center;
    max-width: initial;
  `}

  ${breakpoint.md`
    ${heading['3Xl']}
    padding-top: 56px;
    padding-bottom: 56px;
  `}
`;

const ValuePoint = styled.div`
  display: inline-flex;
  flex-direction: column;
`;

const ValuePointTitle = styled.h3`
  ${heading.lg}
  color: ${text.strong};
  padding-bottom: 8px;

  ${breakpoint.md`
    padding-bottom: 16px;
  `}
`;

const ValuePointInfo = styled.p`
  ${body.md}
  color: ${text.default};
`;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-top: 56px;
  padding-bottom: 24px;
  width: 100%;

  ${breakpoint.sm`
    padding-top: 80px;
    padding-bottom: 40px;
  `}

  ${breakpoint.md`
    padding-top: 0;
    padding-bottom: 56px;
  `}
`;

export { Container, InlineIcon, Row, Rows, Title, ValuePoint, ValuePointTitle, ValuePointInfo };
